// allows sub-addressing
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
